import { Pipe,PipeTransform } from '@angular/core';

@Pipe({
  name: 'mapToIterable',
  standalone: true,
})
export class MapToIterable implements PipeTransform {
  transform(dict: object): Array<any> {
    const a = [];
    for (const key in dict) {
      if (dict.hasOwnProperty(key)) {
        a.push({ key: key, val: dict[key] });
      }
    }
    return a;
  }
}
